<template>
  <div id="root">
    <div id="app" class="logged-in" style="background:#212529">
      <div id="nav" class="mobileRoomTopNav_3gjO3">
        <div class="content_1QLZB">
          <div class="right_1XMld">

            <h3 style="color:white;margin-right: 15px;font-weight: bold;" class="pageTitle_36g65">سبک ها</h3>

          </div>
          <div :style="isMobile == true ? 'margin-left:20px;' : 'margin-left:40px'" class="left_3cl7J">
            <button @click="$router.back()" class="p-button p-component tu-button btn-tertiary backBtn_U6DGe"
              type="button">
              <i class="fa-solid fa-arrow-left" style="font-size:20px;color:rgb(209, 208, 208)"></i>
            </button>
          </div>
        </div>
      </div>
      <div id="app-menu">
        <div id="app-menu-content-wrapper">
          <div id="app-menu-content" :style="isMobile == true ? '' : 'margin-top:20px'">
            <div
              :style="isMobile == true ? 'width:90vw;height:50px;display:flex;padding: 7px;' : 'width:40vw;height:50px;display:flex;padding: 7px;margin:auto'"
              class="quick-nav-item text-button">
              <input
                style="width:90%;height:100%;display:block;padding:7px;font-size:17px;font-family: IRANSansWeb;color:white;outline: none;"
                placeholder="جستجو در سبک ها..." v-on:keydown.enter.prevent="search()" @keyup="tryToSearch()"
                v-model="searchbox" enterkeyhint="done" name="" required="" />
              <i @click="search()" class="fa-solid fa-magnifying-glass" aria-hidden="true"
                style="color: rgb(185, 185, 185);display: block;font-size: 25px;margin: auto;"></i>
            </div>

          </div>
          <section class="StyleGridLayout_container__Qi_db StylesGridLayoutMultiplier_column_1__s1ijB">
            <section class="StyleGridLayout_masonry_wrapper__eWxof" style="--numberOfColumns: 1;">
              <section class="GridColumn_page_wrapper__qfSPy" style="--numberOfColumns: 1;">
                <article class="GridColumn_column_wrapper__ETGpk" style="--totalCountOfElements: 10;">
                  <div v-for="style in styles" :key="style.id"
                    @click="selectedStyle(style.styleId, style.name, style.image3)"
                    class="GridColumn_item_set_dimensions__LhJJk">
                    <div class="StyleCard_card_wrapper__tqRwS">
                      <a class="StyleCard_card_link__4sjNM">
                        <div class="StyleCard_style_name__V1MyA">
                          <p class="typography_text_sm__medium__YFfpR">{{ style.nameFa != '' ? style.nameFa : style.name
                            }}
                          </p>
                        </div>
                        <figure class="StyleCard_secondary_top_right__gmuY3"><img :alt="style.name" loading="lazy"
                            decoding="async" data-nimg="fill" class="StyleCard_image__oC8AB"
                            sizes="(max-width: 640px) 20vw, 15vw" :srcset="style.image1" :src="style.image1"
                            style="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;">
                        </figure>
                        <figure class="StyleCard_secondary_bottom_left__1Pq0p"><img :alt="style.name" loading="lazy"
                            decoding="async" data-nimg="fill" class="StyleCard_image__oC8AB"
                            sizes="(max-width: 640px) 20vw, 15vw" :srcset="style.image2" :src="style.image2"
                            style="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;">
                        </figure>
                        <figure class="StyleCard_main_image_container__I5kEW"><img :alt="style.name"
                            fetchpriority="high" decoding="async" data-nimg="fill" class="StyleCard_main_image__O5NDG"
                            sizes="(max-width: 640px) 60vw, (max-width: 1024px) 40vw, 22.5vw" :srcset="style.image3"
                            :src="style.image3"
                            style="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;">
                        </figure>
                      </a>
                    </div>
                  </div>
                </article>
              </section>
            </section>
          </section>
        </div>
      </div>

    </div>


  </div>
</template>
<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
var Timer;
export default {
  name: 'App',

  data() {
    return {
      showNameDialog: false,
      name: "",
      credit: 0,
      mobile: null,
      chosenName: "",
      texts: [],
      inputText: "",
      searchbox: "",
      isLoading: false,
      currentPage: 1,
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,
      styles: [

      ]
    };
  },
  methods: {
    selectedStyle(id, name, image) {
      console.log(name);
      localStorage.setItem("selectedStyleId", id);
      localStorage.setItem("selectedStyleName", name);
      localStorage.setItem("selectedStyleImage", image);
      router.push("imagegeneration")
    },
    tryToSearch() {
      clearTimeout(Timer);
      Timer = setTimeout(this.search, 1000);
    },
    search() {
      this.currentPage = 1;
      this.isLoading = false;
      this.loadQuotes(this.currentPage, 10);
    },
    loadQuotes(currentPage, limit) {
      this.isLoading = true;

      var url = "https://api.roboo.ir/api/image/GetStyles?currentPage=" + currentPage + "&limit=" + limit;
      if (this.searchbox != "") {
        url = "https://api.roboo.ir/api/image/GetStyles?currentPage=" + currentPage + "&limit=" + limit + "&search=" + this.searchbox;
      }
      axios.get(url)
        .then(response => {
          console.log(response.data)

          if (response.data) {
            var temp = this.styles;
            if (currentPage == 1)
              this.styles = response.data;
            else
              this.styles = this.styles.concat(response.data);
            if (response.data.length > 0)
              this.isLoading = false;
            if (response.data.length == 0) {
              this.isLoading = true;
            }
          }
        }).catch(() => {
        }
        );
    },
  },
  mounted() {
    this.currentPage = 1;
    this.styles = [];
    var that = this;
    this.isLoading = false;
    var path = this.$route.path;
    this.loadQuotes(this.currentPage, 10);
    const onScroll = () => {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = document.documentElement;
      if (that.$route.path != path) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        that.currentPage++;
        if (that.isLoading == false)
          that.loadQuotes(that.currentPage, 10);
      }
    }
    window.addEventListener('scroll', onScroll, {
      passive: true
    });


  }
}
</script>
<style lang="scss" scoped>
#app-menu {
  margin-top: 40px;
}

.Layout_layout__VydZQ {
  flex-grow: 1
}

.Layout_dark__B1IQz {
  color-scheme: dark;
  background-color: #171717
}

.Layout_light__AsDNG {
  background-color: #fff
}

.__className_a64ecd {
  font-family: __Inter_a64ecd, __Inter_Fallback_a64ecd;
  font-style: normal
}

@keyframes Image_placeHolderShimmer__F0D2D {
  0% {
    background-position: -50% 0
  }

  to {
    background-position: 50% 0
  }
}

.Image_animatedBackground__gtxw7 {
  width: 100%;
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: Image_placeHolderShimmer__F0D2D;
  animation-timing-function: linear;
  height: 100%;
  position: absolute;
  inset: 0;
  z-index: 0;
  border: none
}

.Image_background_dark__KBsZj {
  background: linear-gradient(90deg, hsla(0, 0%, 93%, .1) 10%, rgba(62, 62, 62, .3) 18%, hsla(0, 0%, 93%, .1) 33%);
  background-size: 300% 200%
}

.Image_background_light__sjoiQ {
  background: linear-gradient(90deg, #eee 10%, #ddd 18%, #eee 33%);
  background-size: 300% 200%
}

.StyleCard_image__oC8AB,
.StyleCard_main_image__O5NDG {
  object-fit: cover;
  border: none;
  border-radius: 16px
}

.StyleCard_secondary_bottom_left__1Pq0p,
.StyleCard_secondary_top_right__gmuY3 {
  position: absolute;
  border-radius: 16px;
  border: 1px solid transparent;
  height: 0;
  top: 50%;
  left: 50%;
  overflow: hidden;
  z-index: 0;
  transition: transform .3s cubic-bezier(.4, .14, .3, 1) .2s, z-index .3s cubic-bezier(.4, .14, .3, 1) .2s
}

.StyleCard_secondary_bottom_left__1Pq0p:before,
.StyleCard_secondary_top_right__gmuY3:before {
  content: "";
  display: block;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background-color: #000;
  opacity: .3;
  z-index: 1
}
.StyleCard_card_link__4sjNM:hover .StyleCard_secondary_top_right__gmuY3,
.StyleCard_card_link__4sjNM:hover .StyleCard_secondary_bottom_left__1Pq0p {
  // On hover, make them even more visible
  z-index:2;
}
.StyleCard_card_placeholder__qptV7 {
  display: flex;
  background-color: hsla(0, 0%, 100%, .1);
  width: 100%;
  height: 100%;
  border-radius: 16px
}

.StyleCard_card_wrapper__tqRwS {
  position: relative;
  width: 100%;
  height: 100%
}

.StyleCard_main_image_container__I5kEW {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  width: 100%;
  height: 0;
  padding-top: 100%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, .1), 0 7px 15px 0 rgba(0, 0, 0, .1), 0 26px 26px 0 rgba(0, 0, 0, .09), 0 59px 36px 0 rgba(0, 0, 0, .05), 0 106px 42px 0 rgba(0, 0, 0, .01), 0 165px 46px 0 transparent
}

.StyleCard_main_image_container__I5kEW:before {
  content: "";
  display: block;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background-color: #000;
  transition: opacity .3s ease-in-out .2s;
  opacity: 0;
  z-index: 1
}

.StyleCard_main_image_container_darkened__jurTQ:before {
  opacity: .4
}

.StyleCard_secondary_top_right__gmuY3 {
  width: 40%;
  padding-top: 40%;
  transform: translate(10%, -145%) rotate(8deg)
}

.StyleCard_secondary_bottom_left__1Pq0p {
  width: 45%;
  padding-top: 45%;
  transform: translate(-95%, 25%) rotate(-12deg)
}

.StyleCard_main_image__O5NDG {
  border: 1px solid hsla(0, 0%, 100%, .1)
}

.StyleCard_style_name__V1MyA {
  position: absolute;
  top: 14px;
  left: 14px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  z-index: 1;
  padding: 8px 16px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, .25);
  color: #f5f5f5;
  transition: background-color .1s
}

.StyleCard_style_name__V1MyA p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
}

.StyleCard_card_link__4sjNM {
  height: 100%;
  background-color: hsla(0, 0%, 100%, .1);
  border: 1px solid hsla(0, 0%, 100%, .1);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  position: relative;
  z-index: 1;
  cursor: pointer;
  transform: scale(1);
  transition: .1s ease-in-out
}

.StyleCard_card_link__hovered___0Fzm .StyleCard_main_image_container__I5kEW:before {
  opacity: 0
}

.StyleCard_card_link__hovered___0Fzm .StyleCard_secondary_top_right__gmuY3 {
  transform: translate(10%, -150%) scale(1.3) rotate(15deg);
  border: 1px solid hsla(0, 0%, 100%, .07);
  z-index: 1
}

.StyleCard_card_link__hovered___0Fzm .StyleCard_secondary_top_right__gmuY3:before {
  opacity: 0
}

.StyleCard_card_link__hovered___0Fzm .StyleCard_secondary_bottom_left__1Pq0p {
  transform: translate(-95%, 40%) scale(1.2) rotate(-15deg);
  border: 1px solid hsla(0, 0%, 100%, .07);
  z-index: 1
}

.StyleCard_card_link__hovered___0Fzm .StyleCard_secondary_bottom_left__1Pq0p:before {
  opacity: 0
}

.StyleCard_card_link__clicking__x4K6V {
  transform: scale(.95);
  background-color: hsla(0, 0%, 100%, .2)
}

.StyleCard_card_link__disabled__M0Kog {
  pointer-events: none
}

.StyleCard_spinner__sicsm {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background-color: rgba(0, 0, 0, .25);
  border-radius: 100%;
  -webkit-backdrop-filter: blur(17.5px);
  backdrop-filter: blur(17.5px)
}

@media(min-width:768px) {
  .GridColumn_item_set_dimensions__LhJJk {
    width: 30vw;
    height: 30vw;
    display: inline-flex;
    position: relative;
    margin: 0 auto 0 auto;
  }

  .GridColumn_page_wrapper__qfSPy .GridColumn_item_set_dimensions__LhJJk {
    height: 40vw
  }
}

@media(max-width:767px) {
  .GridColumn_item_set_dimensions__LhJJk {
    width: 100%;
    display: inline-flex;
    position: relative
  }

  .GridColumn_page_wrapper__qfSPy .GridColumn_item_set_dimensions__LhJJk {
    height: var(--itemHeight)
  }
}

.GridColumn_column_wrapper__ETGpk,
.GridColumn_page_wrapper__qfSPy {
  width: 100%;
  display: flex;
  flex-direction: column
}

.GridColumn_page_wrapper__qfSPy {
  --containerPaddingLeftPlusRight: 32px;
  --containerSize: 100vw;
  --gapSize: 24px;
  --cardAspectRatio: 1.3;
  --columnWidth: calc((var(--containerSize) - var(--containerPaddingLeftPlusRight) - (var(--numberOfColumns) - 1) * var(--gapSize)) / var(--numberOfColumns));
  --itemHeight: calc(var(--columnWidth) * var(--cardAspectRatio));
  --sumOfTotalElementsHeight: calc(var(--itemHeight) * var(--totalCountOfElements));
  height: auto;
  min-height: 100vh;
  gap: var(--gapSize)
}

.GridColumn_page_wrapper__qfSPy .GridColumn_column_wrapper__ETGpk {
  min-height: calc(var(--itemHeight)*var(--totalCountOfElements) + (var(--totalCountOfElements) - 1)*var(--gapSize));
  gap: var(--gapSize)
}



@media(min-width:768px) {
  .GridColumn_page_wrapper__qfSPy {
    --containerPaddingLeftPlusRight: 144px;
    --gapSize: 56px
  }
}

@media(min-width:1615px) {
  .GridColumn_page_wrapper__qfSPy {
    --containerPaddingLeftPlusRight: 0px;
    --containerSize: 1456px
  }
}

.StyleGridLayout_container__Qi_db {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  outline: none;
  padding: 16px;
  position: relative
}

@media(min-width:768px) {
  .StyleGridLayout_container__Qi_db {
    padding: 48px 72px
  }
}

@media(min-width:1024px) {
  .StyleGridLayout_container__Qi_db {
    padding: 48px 72px 80px
  }
}

.StyleGridLayout_masonry_wrapper__eWxof {
  display: grid;
  grid-template-columns: repeat(var(--numberOfColumns), 1fr);
  grid-gap: 24px;
  gap: 24px
}

@media(min-width:1024px) {
  .StyleGridLayout_masonry_wrapper__eWxof {
    gap: 56px
  }
}

.StylesGridLayoutMultiplier_column_1__s1ijB {
  display: inherit
}


.StylesGridLayoutMultiplier_column_2__O53ex {
  display: none
}

@media((min-width:640px) and (max-width:1023px)) {
  .StylesGridLayoutMultiplier_column_2__O53ex {
    display: inherit
  }
}

.StylesGridLayoutMultiplier_column_3__ZcVi8 {
  display: none
}

@media(min-width:1024px) {
  .StylesGridLayoutMultiplier_column_3__ZcVi8 {
    display: inherit
  }
}

.StylesGridLayoutMultiplier_margin__NN7oM {
  margin-top: 88px
}

@media(min-width:768px) {
  .StylesGridLayoutMultiplier_margin__NN7oM {
    margin-top: 48px
  }
}

@keyframes ChromaticBackground_fadeIn__328ZS {
  0% {
    opacity: 0;
    visibility: hidden
  }

  to {
    opacity: 1;
    visibility: visible
  }
}

.ChromaticBackground_shapes_container__YI4pD {
  width: 100%;
  max-width: 100%;
  z-index: 0;
  inset: 0;
  pointer-events: none;
  opacity: .3;
  filter: blur(200px);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden
}

.ChromaticBackground_shapes_container__YI4pD svg {
  width: 100%;
  height: 100vh;
  animation: ChromaticBackground_fadeIn__328ZS .6s ease-in
}

.ChromaticBackground_shapes_container__absolute__6_61j {
  position: absolute;
  height: 100%
}

.ChromaticBackground_shapes_container__absolute__6_61j svg {
  height: 100%
}

.ChromaticBackground_shapes_container__fixed__svb29 {
  position: fixed;
  height: 100vh
}

.ChromaticBackground_shapes_container__fixed__svb29 svg {
  height: 100vh
}

.ChromaticBackground_shapes_container__light__MawWk {
  opacity: .2
}

.InputSearch_field_container__YBqBt {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  color: #171717;
  position: relative
}

.InputSearch_input__eNey1,
.InputSearch_input_header__QcRjL,
.InputSearch_input_hero__Jn9xB {
  background: none;
  outline: none;
  border-radius: 0;
  border-radius: 4px;
  width: 100%;
  border: 1px solid transparent;
  color: #404040;
  transition: all .2s
}

.InputSearch_input__eNey1:disabled,
.InputSearch_input_header__QcRjL:disabled,
.InputSearch_input_hero__Jn9xB:disabled {
  cursor: not-allowed
}

.InputSearch_input__eNey1 ::placeholder,
.InputSearch_input_header__QcRjL ::placeholder,
.InputSearch_input_hero__Jn9xB ::placeholder {
  color: #737373
}

.InputSearch_input__eNey1[type=search],
[type=search].InputSearch_input_header__QcRjL,
[type=search].InputSearch_input_hero__Jn9xB {
  -webkit-appearance: none
}

.InputSearch_input__eNey1::-webkit-search-cancel-button,
.InputSearch_input__eNey1::-webkit-search-decoration,
.InputSearch_input__eNey1::-webkit-search-results-button,
.InputSearch_input__eNey1::-webkit-search-results-decoration,
.InputSearch_input_header__QcRjL::-webkit-search-cancel-button,
.InputSearch_input_header__QcRjL::-webkit-search-decoration,
.InputSearch_input_header__QcRjL::-webkit-search-results-button,
.InputSearch_input_header__QcRjL::-webkit-search-results-decoration,
.InputSearch_input_hero__Jn9xB::-webkit-search-cancel-button,
.InputSearch_input_hero__Jn9xB::-webkit-search-decoration,
.InputSearch_input_hero__Jn9xB::-webkit-search-results-button,
.InputSearch_input_hero__Jn9xB::-webkit-search-results-decoration {
  display: none
}

.InputSearch_input_header__QcRjL {
  background-color: hsla(0, 0%, 100%, .7);
  border: 1px solid #e5e5e5;
  border-radius: 1000px;
  padding: 12px 20px 12px 40px;
  line-height: 2.4rem;
  font-weight: 500;
  letter-spacing: -.006em;
  font-size: 1.6rem
}

.InputSearch_input_header__QcRjL ::placeholder {
  font-size: 1.4rem !important
}

.InputSearch_input_header__QcRjL:focus,
.InputSearch_input_header__QcRjL:hover {
  border-color: #a3a3a3;
  border-radius: 1000px
}

@media(min-width:360px) {
  .InputSearch_input_header__QcRjL {
    padding: 8px 30px 8px 48px
  }
}

@media(min-width:768px) {
  .InputSearch_input_header__QcRjL {
    padding: 8px 30px 8px 48px
  }
}

@media(min-width:1024px) {
  .InputSearch_input_header__QcRjL {
    font-size: 1.4rem
  }
}

.InputSearch_input_header__dark_mode__WTbd1 {
  border-radius: 62.4375rem;
  border: 1px solid #262626;
  background: rgba(0, 0, 0, .75);
  -webkit-backdrop-filter: blur(17.5px);
  backdrop-filter: blur(17.5px);
  color: #f5f5f5
}

.InputSearch_input_hero__Jn9xB {
  background-color: #fff;
  line-height: 2.4rem;
  font-weight: 500;
  letter-spacing: -.006em;
  font-size: 1.6rem;
  padding: 12px 68px 12px 32px;
  border-radius: 8px;
  border-bottom: 1px solid #e5e5e5
}

.InputSearch_input_hero__Jn9xB:focus {
  box-shadow: 0 0 0 5px rgba(0, 0, 0, .2);
  border-radius: 8px
}

.InputSearch_input_hero__Jn9xB:hover:not(:focus) {
  box-shadow: 0 0 0 5px rgba(0, 0, 0, .102);
  border-radius: 8px
}

@media(min-width:768px) {
  .InputSearch_input_hero__Jn9xB {
    padding: 16px 120px 16px 48px
  }
}

@media(min-width:1024px) {
  .InputSearch_input_hero__Jn9xB {
    font-size: 1.8rem
  }
}

.InputSearch_input_hero__dark_mode__ZkXod {
  background: rgba(0, 0, 0, .75);
  -webkit-backdrop-filter: blur(17.5px);
  backdrop-filter: blur(17.5px);
  border: 1px solid hsla(0, 0%, 98%, .2);
  color: #f5f5f5
}

.InputSearch_icon__KskDI {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1
}

@media(min-width:768px) {
  .InputSearch_icon__KskDI {
    left: 16px
  }
}

.InputSearch_icon_header__BRX4U {
  width: 16px;
  height: 16px
}

.InputSearch_icon_header__BRX4U svg {
  width: 100%;
  height: 100%
}

.InputSearch_icon_hero__leIp3,
.InputSearch_icon_hero__leIp3 svg {
  width: 16px;
  height: 16px
}

@media(min-width:768px) {

  .InputSearch_icon_hero__leIp3,
  .InputSearch_icon_hero__leIp3 svg {
    height: 24px;
    width: 24px
  }
}

.InputSearch_action__vn3Oq {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%)
}

@media(min-width:768px) {
  .InputSearch_action__vn3Oq {
    right: 8px
  }
}

.Search_form__hAs6E {
  width: 100%
}

.Menu_menu__RiV6s {
  position: fixed;
  inset: 0;
  width: 100%;
  min-height: 100vh;
  z-index: 12;
  background-color: hsla(0, 0%, 4%, .87);
  -webkit-backdrop-filter: blur(18.5px);
  backdrop-filter: blur(18.5px);
  transition: opacity .15s linear;
  opacity: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 20px 16px 120px;
  row-gap: 60px
}

@media(min-width:768px) {
  .Menu_menu__RiV6s {
    padding: 38px 70px;
    align-items: flex-end
  }
}

.Menu_menu_header__LfIov {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between
}

.Menu_menu_links__DwU86 {
  display: flex;
  flex-direction: column;
  gap: 40px
}

@media(min-width:768px) {
  .Menu_menu_links__DwU86 {
    padding-right: 32px
  }
}

.Menu_menu_item__R3nGM {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row-reverse;
  gap: 8px
}

@media(min-width:768px) {
  .Menu_menu_item__R3nGM {
    flex-direction: row
  }
}

.Menu_menu_link__Ouui5 {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #a3a3a3;
  font-size: 3rem;
  line-height: 4rem;
  font-weight: 400;
  letter-spacing: .021em;
  transition: color .15s ease-in-out;
  cursor: pointer
}

.Menu_menu_link__Ouui5:hover {
  color: #fff
}

@media(min-width:768px) {
  .Menu_menu_link__Ouui5 {
    text-align: right;
    letter-spacing: -.088rem
  }
}

.Menu_menu_link__active__HITpm {
  color: #fafafa
}

.Menu_menu_footer__9nG5S {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: auto
}

@media(min-width:768px) {
  .Menu_menu_footer__9nG5S {
    gap: 30px;
    justify-content: end
  }
}

.Menu_menu_enter__XCBV1 {
  opacity: 1;
  pointer-events: auto
}

.Menu_menu_exit__jC1u4 {
  opacity: 0;
  pointer-events: none
}

.Menu_close_button__Fdwil {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer
}

@media(min-width:768px) {
  .Menu_close_button__Fdwil svg {
    width: 24px;
    height: 24px
  }
}

.Menu_close_button__Fdwil svg path {
  fill: #fff
}

.Menu_social__Mb_7_ {
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff
}

@media(min-width:768px) {
  .Menu_menu_logo__qjCb_ {
    width: 126px;
    height: 24px
  }
}

.Menu_spinner_container__fZHRO {
  margin-top: 5px
}

@media(min-width:768px) {
  .Menu_spinner_container__fZHRO {
    margin-top: 0
  }
}

.Menu_sub_menu__TeLA_ {
  display: flex;
  flex-direction: column;
  gap: 40px;
  overflow: hidden;
  max-height: 0;
  transition: max-height .3s ease-in-out
}

.Menu_sub_menu__open__zyIsz {
  max-height: var(--submenu-height)
}

.Menu_sub_menu_list__y8QRX {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-top: 40px;
  padding-right: 26px
}

.HelpButton_help_container__1DDln {
  position: relative;
  margin-left: auto
}

@media(min-width:768px) {
  .HelpButton_help_container__1DDln {
    margin-left: 0;
    margin-right: auto
  }
}

.HelpButton_help_button__F0Bw_ {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  border-radius: 100px;
  background: rgba(0, 0, 0, .4);
  -webkit-backdrop-filter: blur(12.5px);
  backdrop-filter: blur(12.5px);
  border: none;
  color: #e5e5e5;
  width: 40px;
  height: 40px
}

.HelpButton_help_button__F0Bw_:hover {
  background: rgba(0, 0, 0, .6)
}

@media(min-width:1024px) {
  .HelpButton_help_button__F0Bw_ {
    width: auto;
    height: auto;
    padding: 16px
  }
}

.HelpButton_help_button__active__I9C5S {
  background: rgba(0, 0, 0, .6)
}

.HelpButton_help_button__transparent__h5YH_,
.HelpButton_help_button__transparent__h5YH_:hover {
  background: transparent
}

.HelpButton_help_navigation__OLO0Z {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  z-index: 900;
  animation: HelpButton_fadeIn__wQpbw .2s ease-out;
  background: rgba(38, 38, 38, .25);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px)
}

@media(min-width:1024px) {
  .HelpButton_help_navigation__OLO0Z {
    position: absolute;
    top: 100%;
    bottom: auto;
    padding-top: 8px;
    background-color: transparent;
    -webkit-backdrop-filter: initial;
    backdrop-filter: none;
    animation: HelpButton_fadeIn__wQpbw .15s ease-out
  }
}

.HelpButton_help_menu__Cjq7H {
  position: relative;
  display: grid;
  grid-gap: 24px;
  gap: 24px;
  background-color: #0a0a0a;
  color: #e5e5e5;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  width: 100%;
  border: 1px solid hsla(0, 0%, 100%, .1);
  padding: 24px
}

@media(min-width:1024px) {
  .HelpButton_help_menu__Cjq7H {
    border-radius: 16px;
    padding: 16px;
    gap: 16px;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, .1), 0 4px 10px 0 rgba(0, 0, 0, .1), 0 18px 18px 0 rgba(0, 0, 0, .09), 0 40px 24px 0 rgba(0, 0, 0, .05), 0 70px 28px 0 rgba(0, 0, 0, .01), 0 110px 31px 0 transparent
  }
}

.HelpButton_help_item__LS9cV {
  font-size: 1.8rem;
  line-height: 2.8rem;
  font-weight: 400;
  letter-spacing: -.017em
}

@media(min-width:1024px) {
  .HelpButton_help_item__LS9cV {
    font-size: 1.4rem;
    line-height: 2.4rem
  }
}

.HelpButton_help_item__LS9cV:first-child {
  border-bottom: 1px solid;
  border-color: hsla(0, 0%, 90%, .25);
  padding-bottom: 20px
}

@media(min-width:1024px) {
  .HelpButton_help_item__LS9cV:first-child {
    padding-bottom: 12px;
    border-color: hsla(0, 0%, 90%, .25)
  }
}

.HelpButton_help_copy__lTqvF {
  display: none
}

@media(min-width:1024px) {
  .HelpButton_help_copy__lTqvF {
    display: flex;
    align-items: center;
    gap: 12px
  }

  .HelpButton_help_copy__lTqvF svg {
    margin-bottom: 2px
  }
}

.HelpButton_link__EtSWp {
  display: block;
  color: #e5e5e5
}

.HelpButton_link__EtSWp:hover {
  color: #fafafa
}

.HelpButton_book_icon__lgL_8 {
  display: block;
  min-width: 16px
}

@keyframes HelpButton_fadeIn__wQpbw {
  0% {
    opacity: 0;
    transform: translateY(5px)
  }

  to {
    opacity: 1;
    transform: translate(0)
  }
}

.Header_header_float_navigation__Y3v8k:after,
.Header_header_help_button__6LY5R:after,
.Header_header_search_container__Jpiv6:after {
  content: "";
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  height: 23px;
  margin: auto
}

@media(min-width:768px) {

  .Header_header_float_navigation__Y3v8k:after,
  .Header_header_help_button__6LY5R:after,
  .Header_header_search_container__Jpiv6:after {
    display: block
  }
}

.Header_header__k7wYN {
  width: 100%;
  padding: 20px 16px;
  display: grid;
  grid-template-columns: auto auto 1fr auto;
  align-items: center;
  grid-gap: 8px;
  gap: 8px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 6;
  transition: transform .2s ease-in;
  border-bottom: 1px solid #e5e5e5;
  padding-right: calc(16px + var(--removed-body-scroll-bar-size, 0px)) !important
}

.Header_header__k7wYN:after {
  content: "";
  position: absolute;
  inset: 0;
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  z-index: -1;
  pointer-events: none
}

@media(min-width:768px) {
  .Header_header__k7wYN {
    grid-template-columns: auto 220px 1fr auto;
    padding: 9px 72px;
    gap: 10px;
    padding-right: calc(72px + var(--removed-body-scroll-bar-size, 0px)) !important
  }
}

@media(min-width:1024px) {
  .Header_header__k7wYN {
    gap: 20px
  }
}

.Header_light_translucent_mode__UyC1j {
  --separator-color: hsla(0, 0%, 4%, .1)
}

.Header_light_translucent_mode__UyC1j:after {
  background-color: hsla(0, 0%, 100%, .9)
}

.Header_dark_translucent_mode__HQzH4 {
  --separator-color: hsla(0, 0%, 100%, .1);
  border-bottom: none
}

.Header_dark_translucent_mode__HQzH4:after {
  background-color: hsla(0, 0%, 9%, .7)
}

.Header_logo__bNRID {
  display: none;
  grid-column: 1/2
}

.Header_logo__bNRID svg {
  display: block
}

@media(min-width:768px) {
  .Header_logo__bNRID svg {
    max-width: 83px;
    height: 16px
  }

  .Header_logo__bNRID {
    display: inline-block
  }
}

.Header_logo__visible__fQ11_ {
  display: inline-block
}

.Header_header_search_container__Jpiv6 {
  position: relative;
  width: 100%;
  max-width: 600px;
  grid-column: 1/4
}

.Header_header_search_container__Jpiv6:after {
  right: 0;
  background-color: var(--separator-color)
}

@media(min-width:768px) {
  .Header_header_search_container__Jpiv6 {
    padding-right: 10px;
    margin-left: auto;
    grid-column: 3/4
  }
}

@media(min-width:1024px) {
  .Header_header_search_container__Jpiv6 {
    padding-right: 20px
  }
}

.Header_header_menu___AkAf {
  grid-column: 4/5
}

.Header_header_float_navigation__Y3v8k {
  position: relative
}

.Header_header_float_navigation__Y3v8k:after {
  left: 0;
  background-color: var(--separator-color)
}

@media(min-width:768px) {
  .Header_header_float_navigation__Y3v8k {
    grid-column: 2/3;
    padding-left: 10px
  }
}

@media(min-width:1024px) {
  .Header_header_float_navigation__Y3v8k {
    padding-right: 20px
  }
}

.Header_header_help_button__6LY5R {
  display: none;
  position: relative
}

.Header_header_help_button__6LY5R:after {
  left: 0;
  background-color: var(--separator-color)
}

@media(min-width:768px) {
  .Header_header_help_button__6LY5R {
    display: block;
    grid-column: 2/3;
    padding-left: 10px
  }
}

@media(min-width:1024px) {
  .Header_header_help_button__6LY5R {
    padding-right: 20px
  }
}

.Header_header_animation_start__oTyLr {
  transform: translateY(-100%)
}

.Header_header_animation_show__1GbZ3 {
  transform: translateY(0)
}

.Header_header_animation_hide__JhjkW {
  transform: translateY(-100%)
}

.LoadingImages_imagesWrapper__TbEz1 {
  height: min-content;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: auto;
  grid-gap: 16px;
  gap: 16px;
  padding: 20px 16px;
  width: 100%
}

.LoadingImages_imgLoadingWrapper__NmKto {
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  position: relative;
  cursor: pointer;
  aspect-ratio: 1/1
}

.LoadingImages_imgLoadingWrapper__NmKto img {
  aspect-ratio: 1/1;
  object-fit: cover;
  height: auto !important
}

@keyframes LoadingImages_placeHolderShimmer__3_rb1 {
  0% {
    background-position: -468px 0
  }

  to {
    background-position: 468px 0
  }
}

.LoadingImages_animatedBackground__Smd_u {
  width: 100%;
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: LoadingImages_placeHolderShimmer__3_rb1;
  animation-timing-function: linear;
  background: #a9a9a9;
  background: linear-gradient(90deg, #eee 10%, #ddd 18%, #eee 33%);
  background-size: 800px 104px;
  height: 100%;
  position: relative
}

.CreatorPreviewProfile_preview_creator_title__UaVSk {
  grid-column: 1/span 3;
  display: flex;
  gap: 8px
}

.CreatorPreviewProfile_profile_picture__2eJ88 {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  border: none;
  object-fit: cover
}

.CreatorPreviewProfile_profile_title_and_description__tmzQt {
  cursor: pointer;
  display: flex;
  flex-direction: column
}

.CreatorPreviewProfile_creator_description__lAoLD {
  color: #525252
}

.CreatorPreviewProfile_preview_images__H7pHj {
  position: unset;
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  border: none
}

.CreatorPreviewProfile_preview_actions__xqdnD {
  grid-column: 1/span 3
}

.CreatorPreviewProfile_text_overflow__0pJQb {
  width: 270px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap
}

.CreatorPreviewProfile_imgLoadingWrapper__QJObt {
  height: 100px;
  width: 100px
}

.CreatorPreviewProfile_profile_button__rzdGd {
  width: 100%;
  background-color: #0a0a0a;
  color: #fafafa;
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all .1s;
  position: relative;
  border: 1px solid transparent;
  line-height: 1.6rem;
  font-weight: 500
}

.CreatorPreviewProfile_profile_button__rzdGd svg path {
  fill: #fafafa
}

.CreatorPreviewProfile_profile_button__rzdGd:hover:not(:disabled) {
  background-color: #525252
}

.NavigationItem_align_center__4B1rC {
  text-align: center
}

.NavigationItem_button_comming_soon__j_kcj,
.NavigationItem_navigation_item__8dXhe,
.NavigationItem_text_xs__bold__ar1_5,
.NavigationItem_text_xs__medium__MgzG5,
.NavigationItem_text_xs__semi_bold__GcWsr,
.NavigationItem_text_xs__xMA7g {
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 400
}

@media(min-width:1024px) {

  .NavigationItem_button_comming_soon__j_kcj,
  .NavigationItem_navigation_item__8dXhe,
  .NavigationItem_text_xs__bold__ar1_5,
  .NavigationItem_text_xs__medium__MgzG5,
  .NavigationItem_text_xs__semi_bold__GcWsr,
  .NavigationItem_text_xs__xMA7g {
    font-size: 1.2rem;
    line-height: 1.6rem
  }
}

.NavigationItem_button_comming_soon__j_kcj,
.NavigationItem_navigation_item__8dXhe,
.NavigationItem_text_xs__medium__MgzG5 {
  font-weight: 500
}

.NavigationItem_text_xs__semi_bold__GcWsr {
  font-weight: 600
}

.NavigationItem_text_xs__bold__ar1_5 {
  font-weight: 700
}

.NavigationItem_text_sm__Jlgt3,
.NavigationItem_text_sm__bold__Ym5vL,
.NavigationItem_text_sm__medium__ImQt3 {
  font-size: 1.4rem;
  line-height: 2.4rem;
  font-weight: 400;
  letter-spacing: -.006em
}

@media(min-width:1024px) {

  .NavigationItem_text_sm__Jlgt3,
  .NavigationItem_text_sm__bold__Ym5vL,
  .NavigationItem_text_sm__medium__ImQt3 {
    font-size: 1.4rem;
    line-height: 2.4rem
  }
}

.NavigationItem_text_sm__medium__ImQt3 {
  font-weight: 500
}

.NavigationItem_text_sm__bold__Ym5vL {
  font-weight: 700
}

.NavigationItem_text_base__bold__BCdyD,
.NavigationItem_text_base__dI3_Z,
.NavigationItem_text_base__medium__cDu7_ {
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 400;
  letter-spacing: -.011em
}

@media(min-width:1024px) {

  .NavigationItem_text_base__bold__BCdyD,
  .NavigationItem_text_base__dI3_Z,
  .NavigationItem_text_base__medium__cDu7_ {
    font-size: 1.6rem;
    line-height: 2.4rem
  }
}

.NavigationItem_text_base__medium__cDu7_ {
  font-weight: 500
}

.NavigationItem_text_base__bold__BCdyD {
  font-weight: 700
}

.NavigationItem_text_lg__HhpBs,
.NavigationItem_text_lg__bold__u0ilE,
.NavigationItem_text_lg__medium__5SthA {
  font-size: 1.6rem;
  line-height: 2rem;
  font-weight: 400;
  letter-spacing: -.014em
}

@media(min-width:1024px) {

  .NavigationItem_text_lg__HhpBs,
  .NavigationItem_text_lg__bold__u0ilE,
  .NavigationItem_text_lg__medium__5SthA {
    font-size: 1.8rem;
    line-height: 2.4rem
  }
}

.NavigationItem_text_lg__medium__5SthA {
  font-weight: 500
}

.NavigationItem_text_lg__bold__u0ilE {
  font-weight: 700
}

.NavigationItem_text_xl__bold__4l_No,
.NavigationItem_text_xl__medium__GnWgK,
.NavigationItem_text_xl__oxxfX,
.NavigationItem_text_xl__semibold__gfYWL {
  font-size: 1.8rem;
  line-height: 2.8rem;
  font-weight: 400;
  letter-spacing: -.017em
}

@media(min-width:1024px) {

  .NavigationItem_text_xl__bold__4l_No,
  .NavigationItem_text_xl__medium__GnWgK,
  .NavigationItem_text_xl__oxxfX,
  .NavigationItem_text_xl__semibold__gfYWL {
    font-size: 2rem;
    line-height: 3.2rem
  }
}

.NavigationItem_text_xl__medium__GnWgK {
  font-weight: 500
}

.NavigationItem_text_xl__semibold__gfYWL {
  font-weight: 600
}

.NavigationItem_text_xl__bold__4l_No {
  font-weight: 700
}

.NavigationItem_text_2xl__KNVYJ,
.NavigationItem_text_2xl__bold__eRi5H,
.NavigationItem_text_2xl__medium__jVCeG {
  font-size: 2.2rem;
  line-height: 2.8rem;
  font-weight: 400;
  letter-spacing: -.019em
}

@media(min-width:1024px) {

  .NavigationItem_text_2xl__KNVYJ,
  .NavigationItem_text_2xl__bold__eRi5H,
  .NavigationItem_text_2xl__medium__jVCeG {
    font-size: 2.4rem;
    line-height: 3.2rem
  }
}

.NavigationItem_text_2xl__medium__jVCeG {
  font-weight: 500
}

.NavigationItem_text_2xl__bold__eRi5H {
  font-weight: 700
}

.NavigationItem_text_3xl__D2E71,
.NavigationItem_text_3xl__bold__eyR2R,
.NavigationItem_text_3xl__medium__FlNjk {
  font-size: 2.8rem;
  line-height: 3.8rem;
  font-weight: 400;
  letter-spacing: .021em
}

@media(min-width:1024px) {

  .NavigationItem_text_3xl__D2E71,
  .NavigationItem_text_3xl__bold__eyR2R,
  .NavigationItem_text_3xl__medium__FlNjk {
    font-size: 3rem;
    line-height: 4rem
  }
}

.NavigationItem_text_3xl__medium__FlNjk {
  font-weight: 500
}

.NavigationItem_text_3xl__bold__eyR2R {
  font-weight: 700
}

.NavigationItem_text_4xl__bold__We9OI,
.NavigationItem_text_4xl__medium__6cMz0,
.NavigationItem_text_4xl__wNQKJ {
  font-size: 3.2rem;
  line-height: 4rem;
  font-weight: 400;
  letter-spacing: -.022em
}

@media(min-width:1024px) {

  .NavigationItem_text_4xl__bold__We9OI,
  .NavigationItem_text_4xl__medium__6cMz0,
  .NavigationItem_text_4xl__wNQKJ {
    font-size: 4rem;
    line-height: 5.6rem
  }
}

.NavigationItem_text_4xl__medium__6cMz0 {
  font-weight: 500
}

.NavigationItem_text_4xl__bold__We9OI {
  font-weight: 700
}

.NavigationItem_button_comming_soon__j_kcj,
.NavigationItem_navigation_item__8dXhe {
  position: relative;
  cursor: pointer;
  display: block;
  width: 100%;
  color: #fff;
  border-radius: 24px;
  padding: 8px 16px;
  letter-spacing: -.0084rem;
  border: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  white-space: nowrap;
  transition: all .15s
}

@media(min-width:360px) {

  .NavigationItem_button_comming_soon__j_kcj,
  .NavigationItem_navigation_item__8dXhe {
    font-size: 1.6rem;
    line-height: 2.4rem
  }
}

@media(min-width:768px) {

  .NavigationItem_button_comming_soon__j_kcj,
  .NavigationItem_navigation_item__8dXhe {
    color: #000;
    padding: 4px 8px;
    font-size: 1.4rem
  }
}

@media(min-width:1024px) {

  .NavigationItem_button_comming_soon__j_kcj,
  .NavigationItem_navigation_item__8dXhe {
    padding: 4px 16px
  }
}

@media(min-width:768px) {

  .NavigationItem_button_comming_soon__dark_mode__Wrw7N,
  .NavigationItem_navigation_item__dark_mode__SudXw {
    color: #e5e5e5;
    padding: 4px 16px
  }

  .NavigationItem_button_comming_soon__hero__BLing,
  .NavigationItem_navigation_item__hero__c9qqq {
    color: #e5e5e5;
    padding: 8px 21px
  }
}

.NavigationItem_navigation_item__8dXhe:hover {
  background-color: rgba(0, 0, 0, .1)
}

@media(min-width:768px) {
  .NavigationItem_navigation_item__current__OKsgi {
    color: #e5e5e5;
    background-color: #171717
  }

  .NavigationItem_navigation_item__current__OKsgi:hover {
    background-color: #171717
  }
}

.NavigationItem_navigation_item__hero__c9qqq.NavigationItem_navigation_item__current__OKsgi {
  background-color: transparent
}

.NavigationItem_navigation_item__loading__m2Nky .NavigationItem_spinner__TK8Ve {
  opacity: 1
}

.NavigationItem_navigation_item__loading__m2Nky .NavigationItem_button_label__7D9Zi {
  opacity: 0
}

.NavigationItem_button_comming_soon__hover__XMZ4U {
  background-color: #000;
  color: #fff
}

.NavigationItem_button_comming_soon__hover__XMZ4U svg {
  animation: NavigationItem_stroke__fZytJ 1s linear
}

.NavigationItem_button_comming_soon_line__FDYB9 {
  position: absolute;
  inset: 0;
  mix-blend-mode: hard-light;
  pointer-events: none;
  z-index: 1
}

.NavigationItem_button_comming_soon_line__FDYB9>div {
  position: absolute;
  inset: 0
}

.NavigationItem_button_comming_soon_line__FDYB9>div:last-child {
  transform: rotate(180deg)
}

.NavigationItem_button_comming_soon_line__FDYB9>div svg {
  display: block;
  position: absolute;
  inset: 0;
  overflow: visible;
  fill: none;
  stroke-width: 2;
  stroke: #fff;
  width: 100%;
  height: 100%;
  stroke-dasharray: 2 10;
  stroke-dashoffset: 14;
  opacity: 0
}

.NavigationItem_button_comming_soon_line__FDYB9>div svg:nth-child(2) {
  stroke-width: 6px;
  filter: blur(20px)
}

.NavigationItem_button_comming_soon_line__FDYB9>div svg:nth-child(3) {
  stroke-width: 5px;
  filter: blur(6px)
}

.NavigationItem_button_comming_soon_line__FDYB9>div svg:nth-child(4) {
  stroke-width: 10px;
  filter: blur(56px)
}

.NavigationItem_button_comming_soon_message__Caf76 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity .2s;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: .9em
}

.NavigationItem_button_comming_soon_message__hover__WnebK {
  opacity: 1
}

.NavigationItem_button_comming_soon_text__hYBTz {
  opacity: 1;
  transition: opacity .2s
}

.NavigationItem_button_comming_soon_text__hover__F2wLf {
  opacity: 0
}

.NavigationItem_spinner__TK8Ve {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  pointer-events: none
}

.NavigationItem_button_label__7D9Zi {
  opacity: 1
}

@keyframes NavigationItem_stroke__fZytJ {

  30%,
  55% {
    opacity: 1
  }

  to {
    stroke-dashoffset: 4;
    opacity: 0
  }
}

.FloatNavigation_float_navigation__bhiwS {
  --gap: 8px;
  --padding-y: 10px;
  --padding-x: 12px;
  --pseudo-element-width: calc((100% / var(--number-of-links)) - var(--gap) - var(--padding-x) + ((var(--gap) + var(--padding-x)) / var(--number-of-links)));
  position: fixed;
  bottom: 0;
  background-color: rgba(0, 0, 0, .9);
  z-index: 3;
  bottom: 20px;
  left: 16px;
  right: 16px;
  border-radius: 100px;
  -webkit-backdrop-filter: blur(22.5px);
  backdrop-filter: blur(22.5px);
  padding: var(--padding-y) var(--padding-x);
  transform: translateY(0);
  transition: transform .15s linear;
  max-width: 450px;
  margin: 0 auto
}

.FloatNavigation_float_navigation__bhiwS:after {
  content: "";
  position: absolute;
  top: var(--padding-y);
  bottom: var(--padding-y);
  right: var(--padding-x);
  left: var(--current-position);
  max-width: var(--pseudo-element-width);
  background-color: hsla(0, 0%, 100%, .1);
  border-radius: 24px;
  pointer-events: none;
  transition: left .15s linear;
  z-index: -1
}

@media(min-width:768px) {
  .FloatNavigation_float_navigation__bhiwS {
    --padding-y: 0px;
    --padding-x: 0px;
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    padding: 0;
    margin: 0;
    background-color: initial;
    -webkit-backdrop-filter: blur(0);
    backdrop-filter: blur(0);
    max-width: 297px
  }
}

.FloatNavigation_float_navigation__hero__Y_Ai5 {
  background-color: rgba(0, 0, 0, .4);
  padding: var(--padding-y) var(--padding-x);
  -webkit-backdrop-filter: blur(22.5px);
  backdrop-filter: blur(22.5px);
  width: 100%;
  margin: 0 auto
}

.FloatNavigation_float_navigation__hero__Y_Ai5:after {
  top: var(--padding-y);
  bottom: var(--padding-y);
  background-color: hsla(0, 0%, 100%, .1)
}

@media(min-width:768px) {
  .FloatNavigation_float_navigation__hero__Y_Ai5 {
    --padding-y: 8px;
    --padding-x: 8px
  }
}

.FloatNavigation_float_navigation__hidden__snCUS {
  transform: translateY(calc(100% + 20px))
}

@media(min-width:768px) {
  .FloatNavigation_float_navigation__hidden__snCUS {
    transform: translateY(0)
  }
}

.FloatNavigation_float_navigation_list__WjtyC {
  display: flex;
  justify-content: center;
  gap: var(--gap)
}

.FloatNavigation_float_navigation_list_item__2_wNK {
  flex: 1 1;
  text-align: center
}

.Hero_hero__xLqvF {
  position: relative;
  padding: 32px 0;
  z-index: 3
}

.Hero_hero__menu_open__XcNM9 {
  z-index: 5
}

@media(min-width:768px) {
  .Hero_hero_relative__Kll_v {
    padding: 100px 0 80px
  }
}

@media(min-width:1024px) {
  .Hero_hero_relative__Kll_v {
    padding: 174px 0 108px
  }
}

@media(min-width:768px) {
  .Hero_hero_relative_small__Pourd {
    padding: 100px 0 40px
  }
}

@media(min-width:1024px) {
  .Hero_hero_relative_small__Pourd {
    padding: 130px 0 62px
  }
}

.Hero_hero_container__5za69 {
  width: 100%;
  filter: brightness(.8);
  position: absolute;
  object-fit: cover;
  border: 0
}

.Hero_profile_picture__twMPp {
  cursor: pointer;
  border: 0;
  border-radius: 18px;
  object-fit: cover;
  width: 18px;
  height: 18px
}

@media(min-width:768px) {
  .Hero_heading_container__4n6Ae {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    color: hsla(0, 0%, 100%, .79);
    text-align: center;
    z-index: 1
  }
}

.Hero_logo__etDtO {
  display: none
}

@media(min-width:768px) {
  .Hero_logo__etDtO {
    display: block;
    width: 142px;
    z-index: 1
  }

  .Hero_logo__etDtO svg {
    width: 100%
  }
}

.Hero_logo_mobile__Ym6E4 {
  width: 92px;
  z-index: 1
}

.Hero_logo_mobile__Ym6E4 svg {
  width: 100%
}

@media(min-width:768px) {
  .Hero_logo_mobile__Ym6E4 {
    display: none
  }
}

.Hero_hero_main_content__Jt36E {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  gap: 16px;
  padding: 0 16px;
  z-index: 2;
  position: relative
}

@media(min-width:768px) {
  .Hero_hero_main_content__Jt36E {
    width: 100%;
    padding: 0 72px;
    gap: 40px
  }
}

@media(min-width:1024px) {
  .Hero_hero_main_content__Jt36E {
    width: 70%;
    padding: 0 72px
  }
}

@media(min-width:1200px) {
  .Hero_hero_main_content__Jt36E {
    width: 60%
  }
}

@media(min-width:1900px) {
  .Hero_hero_main_content__Jt36E {
    width: 50%
  }
}

.Hero_heading__ZoE7i {
  display: none
}

@media(min-width:768px) {
  .Hero_heading__ZoE7i {
    display: block
  }
}

.Hero_nav_container__uR9Lv {
  z-index: 5;
  display: flex;
  align-items: center;
  padding: 0 16px 16px;
  justify-content: space-between
}

@media(min-width:768px) {
  .Hero_nav_container__uR9Lv {
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    top: 16px;
    left: 0;
    right: 0;
    padding: 2px 72px 0
  }

  .Hero_nav_container__has_float_navigation__uLWf9 {
    display: grid;
    grid-template-columns: repeat(3, 1fr)
  }
}

.Hero_hero_content__7LVDz {
  display: none
}

@media(min-width:768px) {
  .Hero_hero_content__7LVDz {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    justify-content: flex-start
  }
}

.Hero_invisible_container__OdOL3 {
  right: 0;
  bottom: 0;
  margin-bottom: 10px;
  margin-right: 80px;
  height: 46px;
  z-index: 3;
  display: none;
  position: absolute
}

@media(min-width:1024px) {
  .Hero_invisible_container__OdOL3 {
    display: flex
  }
}

.Hero_creator_image_by__y8vau {
  white-space: nowrap
}

.Hero_creator_name__7uC5_ {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer
}

.Hero_creator_container__DSyp_ {
  height: 40px;
  color: #fff;
  display: flex;
  position: relative;
  bottom: 0;
  right: 0;
  padding: 8px 16px;
  background-color: rgba(38, 38, 38, .4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  border-radius: 8px;
  gap: 4px;
  align-items: center;
  justify-content: center
}

.Hero_preview_profile__XmLVU {
  display: grid;
  grid-template-columns: auto auto auto;
  cursor: default;
  position: absolute;
  top: 110%;
  left: -70%;
  grid-gap: 8px;
  gap: 8px;
  padding: 20px;
  background-color: #fafafa;
  border-radius: 8px;
  color: #0a0a0a;
  max-width: 372px;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, .1), 0 7px 15px 0 rgba(0, 0, 0, .1), 0 26px 26px 0 rgba(0, 0, 0, .09), 0 59px 36px 0 rgba(0, 0, 0, .05), 0 106px 42px 0 rgba(0, 0, 0, .01), 0 165px 46px 0 transparent
}

.Hero_profile_picture_container__gIUYn {
  position: relative;
  width: 100%;
  min-width: 18px;
  max-width: 18px;
  height: 18px
}

.Hero_preview_tooltip__iAZ2p:after {
  display: flex;
  content: "";
  position: absolute;
  top: 200%;
  left: 50%;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: #fafafa;
  border-top: 0;
  margin-left: -6px;
  margin-top: -6px;
  translate: 0 -50%
}

@media(min-width:768px) {
  .Hero_main_navigation__a5_3U {
    justify-content: flex-end;
    grid-column: 2/3
  }

  .Hero_menu__nE6JY {
    justify-self: end
  }
}

.circle-div {
  background-color: #6153cc;
  height: 60px;
  width: 60px;
  border-radius: 100%;
  position: fixed;
  bottom: 15px;
  right: 20px;
}

::placeholder {
  color: rgb(185, 185, 185);
  opacity: 1;
  /* Firefox */
}

::-ms-input-placeholder {
  /* Edge 12 -18 */
  color: rgb(185, 185, 185);
}

.login-box {
  top: 50%;
  left: 50%;
  position: fixed;
  width: 300px;
  padding: 10px;
  transform: translate(-50%, -50%);
  z-index: 10000;
  background-color: rgb(24, 24, 24);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
  border-radius: 10px;

}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

span {
  font-family: IRANSansWeb;
  font-weight: bold;
}

@function gray($color) {
  @return rgb($color, $color, $color);
}

$red: rgb(239, 83, 80);
$orange: rgb(255, 160, 0);
$yellow: rgb(253, 216, 53);
$green: rgb(42, 252, 152);
$indigo: rgb(57, 73, 171);
$violet: rgb(103, 58, 183);

/* -- */

$blue: rgb(66, 165, 245);

@keyframes blink {

  from,
  25%,
  to {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(720deg);
  }

  to {
    transform: rotate(1440deg);
  }
}

@keyframes bounce {

  from,
  6.66%,
  17.66%,
  33.33% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  13.33%,
  14.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  23.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  26.66% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  30% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}

body {
  margin: 0px;
  overflow-x: hidden;
  padding: 0px;

  &::-webkit-scrollbar-track {
    background-color: gray(30);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(white, 0.2);
    border-radius: 100px;
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  input,
  h1,
  h3,
  a,
  span {
    color: gray(90);
    font-family: IRANSansWeb;
    font-weight: bold;
    font-weight: 400;
    margin: 0px;
    padding: 0px;
  }
}

$backgroundImage: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2076&q=80";

.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.clear-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.1);
  border-radius: 100px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

.text-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

#app {
  background-color: gray(30);

  &.logged-out {
    #app-info {
      margin-left: 40px;
      opacity: 1;
      transform: translateX(0%);
    }

    #app-background {
      cursor: pointer;
    }

    #sign-in-button-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -40px);
    }
  }

  &.logging-in,
  &.verifying-log-in,
  &.log-in-error {
    #app-background {
      #app-background-image {
        filter: blur(8px);
        transform: scale(1.2);
      }
    }
  }

  &.logging-in,
  &.log-in-error {
    #app-pin-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  &.verifying-log-in {
    #app-loading-icon {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  &.log-in-error {
    #app-pin-wrapper {
      #app-pin {
        .app-pin-digit {
          background-color: rgba($red, 0.05);
          border-color: rgba($red, 0.5);
        }
      }
    }
  }

  &.logged-in {
    #app-menu {
      opacity: 1;
      pointer-events: all;
    }
  }

  .scrollable-component {
    cursor: grab;
    overflow: auto;
    user-select: none;
    width: 100%;

    &:active {
      cursor: grabbing;
    }

    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }

  #app-loading-icon {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, 0%);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    i {
      animation: 2s spin ease-in-out infinite;
      color: white;
      font-size: 2em;
    }
  }

  #app-background {
    height: 100%;
    left: 0px;
    overflow: hidden;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 1;

    #app-background-image {
      height: 100%;
      transition: filter 250ms, transform 250ms;
      width: 100%;
    }
  }

  #app-info {
    bottom: 0px;
    left: 0px;
    margin: 40px;
    margin-left: 0px;
    opacity: 0;
    position: absolute;
    transform: translateX(-100%);
    transition: margin 250ms, opacity 250ms, transform 250ms;
    z-index: 2;
  }

  .user-status-button {
    cursor: pointer;
    margin-top: 10px;
    outline: none;
    padding: 10px;
    width: 100px;

    i {
      color: gray(245);
      font-size: 1.25em;
    }
  }

  #sign-in-button-wrapper {
    bottom: 0px;
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%, 40px);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #sign-in-button {
      &:not(:hover) {
        animation: bounce 3s infinite;
        animation-delay: 3s;
      }
    }
  }

  .info {
    align-items: flex-end;
    display: flex;

    .time {
      color: gray(245);
      font-size: 6em;
      height: 80px;
      line-height: 80px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
    }

    .weather {
      display: inline-flex;
      height: 20px;
      margin-bottom: 6px;
      margin-left: 20px;

      i,
      span {
        align-items: center;
        display: inline-flex;
      }

      i {
        color: $yellow;
        font-size: 0.9em;
      }

      span {
        color: white;
      }

      .weather-type {
        height: 20px;
      }

      .weather-temperature-value {
        font-size: 1.5em;
        height: 20px;
        margin-left: 5px;
      }

      .weather-temperature-unit {
        align-items: flex-start;
        font-size: 0.8em;
        margin-left: 3px;
      }
    }
  }

  .reminder {
    display: flex;
    gap: 6px;
    margin-top: 10px;

    i,
    div {
      display: inline-flex;
    }

    i {
      color: gray(245);
      font-size: 0.8em;
      height: 12px;
      line-height: 12px;
    }

    span {
      color: rgba(white, 0.8);
      font-size: 1.1em;
    }

    .reminder-icon {
      align-items: center;
      height: 20px;
    }

    .reminder-time {
      align-items: flex-end;
      color: gray(30);
      font-size: 0.8em;
      height: 20px;
    }
  }

  #quick-nav {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 5px;
    width: 100%;
    z-index: 3;

    .quick-nav-item {
      padding: 10px 20px;

      &:last-of-type {
        margin-right: 10px;
      }

      .quick-nav-item-label {
        color: gray(245);
        text-shadow: 0px 0px 2px rgba(black, 0.1);
      }
    }
  }

  #youtube-link {
    align-items: center;
    display: inline-flex;
    gap: 5px;
    margin-top: 10px;
    padding: 10px 20px;
    text-decoration: none;

    i,
    span {
      height: 20px;
      line-height: 20px;
    }

    i {
      color: $red;
    }

    span {
      color: white;
    }
  }

  .menu-section {
    margin-top: 40px;

    .menu-section-title {
      align-items: center;
      display: flex;
      gap: 6px;

      i,
      span {
        color: gray(245);
      }

      i {
        font-size: 1em;
      }

      .menu-section-title-text {
        color: rgba(white, 0.9);
        font-size: 1.4em;
        font-weight: bold;
      }
    }

    .menu-section-content {
      margin-top: 15px;
      padding-top: 5px;
    }
  }

  #restaurants-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      .restaurant-card {
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 14vw;
        max-height: 240px;
        position: relative;
        transition: transform 250ms;
        width: 25%;

        &:hover {
          transform: translateY(-5px);

          .restaurant-card-content {
            .restaurant-card-content-items {
              margin-bottom: 30px;
            }
          }
        }

        .restaurant-card-content {
          background: linear-gradient(to top, rgba(black, 0.8), transparent);
          border-radius: 10px;
          height: 100%;
          width: 100%;

          .restaurant-card-content-items {
            bottom: 0px;
            display: flex;
            flex-direction: column;
            margin: 20px;
            position: absolute;
            right: 0px;
            text-align: right;
            transition: margin 250ms;

            .restaurant-card-title {
              color: gray(245);
              font-size: 1.5em;
            }

            .restaurant-card-desc {
              color: $blue;
              font-size: 0.9em;
            }
          }
        }
      }
    }
  }

  #weather-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      padding: 5px 0px;
      width: 100%;

      .day-card {
        backdrop-filter: blur(3px);
        background-color: rgba(white, 0.1);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        height: 8vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 180px;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 7);

        &:last-of-type {
          margin-right: 5px;
        }

        .day-card-content {
          display: flex;
          flex-direction: column;
          height: calc(100% - 20px);
          justify-content: space-evenly;
          padding: 10px;

          i,
          span {
            color: gray(245);
            text-align: center;
          }

          .day-weather-temperature {
            align-items: flex-start;
            display: flex;
            font-size: 0.9em;
            justify-content: center;

            .day-weather-temperature-unit {
              font-size: 0.8em;
              margin-left: 3px;
            }
          }

          .day-weather-icon {
            font-size: 3.5em;
            text-shadow: 2px 2px 2px rgba(black, 0.1);

            &.sunny {
              color: $yellow;
            }

            &.rainy,
            &.stormy {
              color: $blue;
            }
          }

          .day-name {
            font-size: 0.9em;
            text-transform: uppercase;
          }
        }
      }
    }
  }

  #tools-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      width: 100%;
      height: 50vh;

      .tool-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 160px;

        position: relative;
        transition: transform 250ms;
        width: calc(100% / 6);

        &:hover {
          transform: translateY(-5px);

          .tool-card-background {
            filter: grayscale(0);
          }
        }

        .tool-card-background {
          border-radius: 10px;
          filter: grayscale(40%);
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: filter 250ms;
          width: 100%;
        }

        .tool-card-content {
          display: flex;

          i,
          span {
            color: gray(245);
            position: absolute;
            width: 100%;
            height: 60%;

          }

          .tool-card-content-header {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .tool-card-label {
              color: $blue;
              font-size: 0.8em;
              text-transform: uppercase;
            }

            .tool-card-name {
              color: white;
              text-align: center;
              bottom: 0;
              font-weight: bold;
              font-size: 1.5em;
            }
          }

          .tool-card-icon {
            color: gray(245);
            font-size: 2em;
          }
        }
      }
    }
  }

  #movies-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      #movie-card-1 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($indigo, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-2 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($violet, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-3 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($red, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-4 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($green, 0.4), rgba(black, 0.1), rgba(black, 0.4));
        }
      }

      .movie-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 40vw;
        max-height: 600px;
        min-height: 460px;
        min-width: 260px;
        overflow: hidden;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 4);

        &:hover {
          transform: translateY(-5px);

          .movie-card-background {
            transform: scale(1.05);
          }

          .movie-card-content {
            i {
              transform: translate(-20%, -20%) scale(1.2);
            }
          }
        }

        .movie-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: transform 250ms;
          width: 100%;
          z-index: 1;
        }

        .movie-card-content {
          background: linear-gradient(to top, rgba(black, 0.5), rgba(black, 0.1), rgba(black, 0.4));
          border-radius: 10px;
          height: 100%;
          position: relative;
          z-index: 2;

          .movie-card-info {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 30px;

            span {
              text-shadow: 2px 2px 2px rgba(black, 0.1);
            }

            .movie-card-title {
              color: gray(245);
              font-size: 1.5em;
              font-weight: bold;
            }

            .movie-card-desc {
              color: gray(200);
              font-size: 0.9em;
            }
          }

          i {
            bottom: 0px;
            color: gray(245);
            font-size: 5em;
            padding: 30px;
            position: absolute;
            right: 0px;
            text-shadow: 2px 2px 2px rgba(black, 0.1);
            transition: transform 250ms;
          }
        }
      }
    }
  }

  #app-pin-wrapper {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -30%) scale(0.8);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #app-pin-label {
      color: gray(245);
      font-size: 0.9em;
      margin: 10px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);

      #app-pin-cancel-text {
        cursor: pointer;
        margin-left: 2px;

        &:hover {
          text-decoration: underline;
        }
      }

      #app-pin-error-text {
        color: $red;
      }
    }

    #app-pin-hidden-input {
      background-color: transparent;
      border: none;
      height: 0px;
      outline: none;
      pointer-events: none;
      position: absolute;
      width: 0px;
    }

    #app-pin {
      display: flex;
      gap: 10px;

      .app-pin-digit {
        align-items: center;
        background-color: rgba(white, 0.05);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 2px rgba(black, 0.06);
        display: inline-flex;
        font-size: 3em;
        height: 80px;
        justify-content: center;
        position: relative;
        transition: background-color 250ms, border-color 250ms;
        width: 60px;

        &:after,
        &:before {
          box-shadow: 2px 2px 2px rgba(black, 0.06);
          content: "";
          position: absolute;
          transition: opacity 250ms, transform 250ms;
          z-index: 2;
        }

        &:before {
          background-color: gray(245);
          border-radius: 10px;
          bottom: 0px;
          height: 3px;
          left: 15%;
          opacity: 0;
          transform: translateY(0px);
          width: 70%;
        }

        &:after {
          background-color: gray(245);
          border-radius: 20px;
          height: 20px;
          opacity: 0;
          transform: scale(0.25);
          width: 20px;
        }

        &.focused {
          &:before {
            animation: blink 2s ease-in-out infinite;
            opacity: 1;
            transform: translateY(-10px);
          }
        }

        &.hidden {
          &:after {
            opacity: 1;
            transform: scale(1);
          }

          .app-pin-digit-value {
            opacity: 0;
            transform: scale(0.25);
          }
        }

        .app-pin-digit-value {
          color: gray(245);
          transition: opacity 250ms, transform 250ms;
        }
      }
    }
  }

  #app-menu {
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    position: relative;
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #app-menu-content-wrapper {
      background: #212529;
      min-height: 80vh;
      padding: 80px;
      padding-top: 0px;

      #app-menu-content {
        margin: auto;
        max-width: 1600px;
        position: relative;

        #app-menu-content-header {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}

p {
  margin-bottom: 0 !important;
}

@media(max-width: 1300px) {
  #app {
    &.logged-out {
      #sign-in-button-wrapper {
        transform: translate(-40px, 0px);
      }
    }

    #sign-in-button-wrapper {
      bottom: 40px;
      left: auto;
      right: 0px;
      transform: translate(40px, 0px);
    }

    #app-menu {
      #app-menu-content-wrapper {
        padding: 20px;

        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-wrap: wrap;

              .restaurant-card {
                height: 22vh;
                ;
                max-height: 300px;
                position: relative;
                width: calc(50% - 0.5em);
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 600px) {
  #app {
    .info {
      .time {
        font-size: 4em;
        height: 60px;
        line-height: 60px;
      }
    }

    .user-status-button {
      width: 60px;
    }

    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-direction: column;

              .restaurant-card {
                height: 40vw;
                position: relative;
                width: 100%;
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 400px) {
  #app {
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

.overflow2 {
  margin: 0 0 0 0;
  text-overflow: ellipsis;
  width: 82vw;
  /**
 * Required properties to achieve text-overflow
 */
  white-space: nowrap;
  overflow: hidden;
}

.overflow {
  margin: 0 0 2em 0;
  text-overflow: ellipsis;
  /**
 * Required properties to achieve text-overflow
 */
  white-space: nowrap;
  overflow: hidden;
}
</style>